import React from "react";
import { Box } from "@mui/material";

// components
import Pevious from "./previous";
import Logo from "./logo";
// ========================================================================================================================
type Props = {
  onPrevious?: () => void;
  hasResults?: boolean;
};

export default function QuestionHeader({ onPrevious, hasResults }: Props) {
  return (
    <Box
      sx={{
        height: "60px",
        background: "#F7F2E8",
        // flex: 1,
        flexGrow: 1,
        borderRadius: "0 0 16px 16px",
        width: "100%",
        // maxWidth: { xs: "100%", lg: "60%" },
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        mx: "auto",
        maxHeight: "64px",
        mb: 2,
      }}
    >
      {onPrevious && <Pevious onClick={onPrevious} hasResults={hasResults} />}
      <Logo />
    </Box>
  );
}
